/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import classnames from 'classnames';
import Close from '@mui/icons-material/Close';

import { Button } from 'uikit/buttons';
import { Typo } from 'uikit/content';
import { Select } from 'uikit/selects';

import styles from '../styles/formFieldSelectItems.module.scss';

const SelectedOptionItem = ({ selectedItem, isReadOnly, handleRemoveSelected }) => (
  <div
    className={classnames(styles.item, { [styles.isReadOnly]: isReadOnly })}
  >
    <Typo
      element="span"
      title={selectedItem.name}
      variant="b01"
    >
      {selectedItem.name}
    </Typo>
    {!isReadOnly && (
      <Button
        variant="ghost"
        size="xsmall"
        icon={<Close />}
        onClick={() => handleRemoveSelected(selectedItem.id)}
      />
    )}
  </div>
);

const FormFieldSelectItems = ({
  fieldId,
  handleAddSelected,
  handleFilterOption,
  handleOnLoadOptions,
  handleRemoveSelected,
  selectedOptions,
  selectProps,
  isReadOnly,
}) => (
  <div className={styles.element}>
    <Select
      isFluid
      isAsync
      id={fieldId}
      key={JSON.stringify(selectedOptions)}
      className={styles.select}
      defaultOptions
      filterOption={handleFilterOption}
      loadOptions={handleOnLoadOptions}
      onChange={handleAddSelected}
      isSearchable={false}
      loadingMessage={() => i18n.t('loading')}
      noOptionsMessage={() => i18n.t('no-matches')}
      {...selectProps}
    />
    {selectedOptions?.map((selectedItem) => (
      <SelectedOptionItem
        key={selectedItem.id}
        selectedItem={selectedItem}
        isReadOnly={isReadOnly}
        handleRemoveSelected={handleRemoveSelected}
      />
    ))}
  </div>
);

FormFieldSelectItems.defaultProps = {
  handleAddSelected: () => {},
  handleOnLoadOptions: () => {},
  handleRemoveSelected: () => {},
  handleFilterOption: () => {},
  selectedOptions: [],
  selectProps: {},
  isReadOnly: false,
};

FormFieldSelectItems.propTypes = {
  fieldId: PropTypes.string.isRequired,
  handleAddSelected: PropTypes.func,
  handleOnLoadOptions: PropTypes.func,
  handleRemoveSelected: PropTypes.func,
  handleFilterOption: PropTypes.func,
  selectedOptions: PropTypes.arrayOf(PropTypes.shape({})),
  selectProps: PropTypes.objectOf(PropTypes.any),
  isReadOnly: PropTypes.bool,
};

export default FormFieldSelectItems;
